export default __webpack_public_path__ + "static/media/CUBS-Ban-Download.225aa408.png";